module.exports = __webpack_public_path__ + "static/images/solution.1a9b3adef674fd414b5a64d091612108.png";